import { Component } from "react";
import Layout from "../../component/layout";
import NextSeoModule from "../../component/next-seo";
import Sappptemplate from "../../component/course/sap-pp";

export default class Sapppinpune extends Component {
 
  render() {
 
    const title = "SAP PP"
    const url ="sap-pp"
    const url1 ="-training-in-pune"
    const location = "pune" 
    const location1="Training in Pune"
    
    return(
      <>
          <NextSeoModule
            title={`${title} ${location1} - learnsoft.org`}
            description={`Learn SAP PP in ${location} and Gain Expertise in Production Planning, Controlling, and Manufacturing Processes to Excel in the Manufacturing Industry.`}
             url={`${location}/${url}${url1}`}
            img={`course/${url}.webp`}
            keyword={`${title} training in Chennai, ${title} certification in Chennai, Online ${title}  Training in Chennai, ${title} Online Training in Chennai, ${title} Syllabus, ${title} Placement Training in Chennai, ${title} course in Chennai, ${title} classes in Chennai, ${title} institute in Chennai, Best ${title} training institute in Chennai, ${title} training and certification in Chennai, Best ${title} training in Chennai, ${title} coaching in Chennai, ${title} training center in Chennai, ${title} training provider in Chennai`}
          />
        <Layout navbarBackgroundColor="#281E1E">
          <Sappptemplate url={url} title={title} url1={url1} relatedlocation={location} location={location} location1={location1} />
        </Layout>
      </>
    );
  }
}
